import { ENDPOINTS } from '../config'
import type { AxiosResponse } from 'axios'
import type { WorkspaceListItem } from '../types/PostGetCurrentUserResInterface'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const getWorkspaces = (): Promise<AxiosResponse<Array<WorkspaceListItem>>> => {
  return AuthAxios.get(ENDPOINTS.ENDPOINT_GET_WORKSPACES)
}

export default getWorkspaces
